import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import "../index.css";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("clientEmail");
    localStorage.removeItem("userId");

    navigate("/");
  };

  return (
   
    
  <div className={`sidebar${isOpen ? ' open' : ''}`}> 
      <div className="sidebar-header">
        {isOpen ? "Menu" : ""}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="btn toggle-btn rounded-circle"
          style={{ float: 'right', marginLeft: '8px' }}
        >
          <span className="toggle-icon">{isOpen ? "«" : "»"}</span>
        </button>
      </div>
      <div className="sidebar-menu">
        <Link to="/Profile" className="sidebar-menu-item">
          {isOpen ? "Profile" : <span className="bi bi-person" />}
        </Link>
        <Link to="/MyBooks" className="sidebar-menu-item">
          {isOpen ? "My Bookings" : <span className="bi bi-book" />}
        </Link>
        <Link to="/settings" className="sidebar-menu-item">
          {isOpen ? "Settings" : <span className="bi bi-gear" />}
        </Link>
      </div>
      <div className="sidebar-footer">
        <button
          onClick={handleLogout}
          className="btn logout-btn w-100"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
